"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Business Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.304
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagsApi = exports.FeatureFlagsApiFactory = exports.FeatureFlagsApiFp = exports.FeatureFlagsApiAxiosParamCreator = exports.FarmStatusApi = exports.FarmStatusApiFactory = exports.FarmStatusApiFp = exports.FarmStatusApiAxiosParamCreator = exports.FarmSettingsApi = exports.FarmSettingsApiFactory = exports.FarmSettingsApiFp = exports.FarmSettingsApiAxiosParamCreator = exports.FarmApi = exports.FarmApiFactory = exports.FarmApiFp = exports.FarmApiAxiosParamCreator = exports.BusinessCleanUpApi = exports.BusinessCleanUpApiFactory = exports.BusinessCleanUpApiFp = exports.BusinessCleanUpApiAxiosParamCreator = exports.GuidanceShiftProfileEnum = exports.FeatureFlagNamesEnum = exports.FarmUpdateEventTypeEnum = exports.FarmTimezone = exports.FarmOperationTypeEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.FarmOperationTypeEnum = {
    DAIRY: 'DAIRY',
    BEEF_AND_SHEEP: 'BEEF_AND_SHEEP',
    BEEF: 'BEEF'
};
/**
 * List of timezone ids we provide support
 * @export
 * @enum {string}
 */
exports.FarmTimezone = {
    PACIFIC_AUCKLAND: 'Pacific/Auckland',
    EUROPE_AMSTERDAM: 'Europe/Amsterdam',
    EUROPE_DUBLIN: 'Europe/Dublin',
    AUSTRALIA_HOBART: 'Australia/Hobart',
    AUSTRALIA_ADELAIDE: 'Australia/Adelaide',
    AUSTRALIA_MELBOURNE: 'Australia/Melbourne',
    AMERICA_LOS_ANGELES: 'America/Los_Angeles',
    AMERICA_DENVER: 'America/Denver',
    AMERICA_CHICAGO: 'America/Chicago',
    AMERICA_CAMPO_GRANDE: 'America/Campo_Grande'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FarmUpdateEventTypeEnum = {
    CREATED: 'Created',
    REMOVED: 'Removed',
    UPDATED: 'Updated'
};
/**
 * PASTURE, HEALTH, PASTURE_FARM_WALK_MODE are all DEPRECATED (but still available for backwards compatibility - soon to be fixed).
 * @export
 * @enum {string}
 */
exports.FeatureFlagNamesEnum = {
    BREAK_FENCE_CREATION_INACTIVE_EDGES: 'BREAK_FENCE_CREATION_INACTIVE_EDGES',
    PROTRACK_DRAFTING: 'PROTRACK_DRAFTING',
    SHIFTING_EXIT_PADDOCK: 'SHIFTING_EXIT_PADDOCK',
    LIMIT_31_EDGE_POLYGON: 'LIMIT_31_EDGE_POLYGON',
    ENABLE_60_POINT_RACEWAYS: 'ENABLE_60_POINT_RACEWAYS',
    SHOW_WEEKLY_ROTATION_TIMELINE_VIEW: 'SHOW_WEEKLY_ROTATION_TIMELINE_VIEW',
    LIMIT_60_MOBS: 'LIMIT_60_MOBS',
    LOCAL_EMERGENCY_RELEASE: 'LOCAL_EMERGENCY_RELEASE',
    IRELAND_STYLE_PASTURE_INPUT: 'IRELAND_STYLE_PASTURE_INPUT',
    ALLOW_TAG_ON_WITH_LORA_UNRESPONSIVE: 'ALLOW_TAG_ON_WITH_LORA_UNRESPONSIVE',
    SHIFT_PADDOCK_TO_PADDOCK: 'SHIFT_PADDOCK_TO_PADDOCK',
    SHIFT_TO_DESTINATION_VIA_WAYPOINTS: 'SHIFT_TO_DESTINATION_VIA_WAYPOINTS',
    COWS_LEFT_IN_PADDOCK_NOTIFICATION: 'COWS_LEFT_IN_PADDOCK_NOTIFICATION',
    PREEMPTIVE_PAUSE: 'PREEMPTIVE_PAUSE',
    PASTURE_SUMMER_CROP: 'PASTURE_SUMMER_CROP',
    BREAK_TOO_SMALL: 'BREAK_TOO_SMALL',
    ALLOCATION_RELEASE: 'ALLOCATION_RELEASE',
    SHOW_UNRELIABLE_COLLAR_LOCATIONS: 'SHOW_UNRELIABLE_COLLAR_LOCATIONS',
    SATELLITE_APC_PLANET_LABS_SUBSCRIPTION: 'SATELLITE_APC_PLANET_LABS_SUBSCRIPTION',
    SATELLITE_APC: 'SATELLITE_APC',
    PHOTO_APC: 'PHOTO_APC',
    PASTURE_PRO_SAAS_TRIAL: 'PASTURE_PRO_SAAS_TRIAL',
    HERD_HEALTH_BEHAVIOUR_TABLE: 'HERD_HEALTH_BEHAVIOUR_TABLE',
    HEAT_AND_HEALTH_ADD_ON: 'HEAT_AND_HEALTH_ADD_ON',
    PASTURE_PRO_PACKAGE: 'PASTURE_PRO_PACKAGE',
    OFFLINE_PHOTO_APC: 'OFFLINE_PHOTO_APC',
    RESIDUAL_AREAS_MAP_LAYER: 'RESIDUAL_AREAS_MAP_LAYER',
    NITROGEN_APPLICATION: 'NITROGEN_APPLICATION',
    NITROGEN_APPLICATION_V2: 'NITROGEN_APPLICATION_V2',
    SHOW_INSIGHTS_BENCHMARK: 'SHOW_INSIGHTS_BENCHMARK',
    SHOW_MATING_INSIGHTS_BENCHMARK: 'SHOW_MATING_INSIGHTS_BENCHMARK',
    ONLY_COMPLETE_B2_B_SHIFTS_BY_COWS_FINISHED_SHIFTING: 'ONLY_COMPLETE_B2B_SHIFTS_BY_COWS_FINISHED_SHIFTING',
    EAR_TAG_PREFIX: 'EAR_TAG_PREFIX',
    COW_NICKNAMES: 'COW_NICKNAMES',
    FESTIVE_MODE: 'FESTIVE_MODE',
    SHIFT_TO_NEW_AREA: 'SHIFT_TO_NEW_AREA',
    LEARNING_CENTRE: 'LEARNING_CENTRE',
    OFFLINE_MODE: 'OFFLINE_MODE',
    PACKAGE_CORE: 'PACKAGE_CORE',
    PACKAGE_PRO: 'PACKAGE_PRO',
    PACKAGE_UNLIMITED: 'PACKAGE_UNLIMITED',
    WATERWAYS: 'WATERWAYS',
    ENABLE_3_D_TERRAIN: 'ENABLE_3D_TERRAIN',
    ALLOW_TAG_ON_WITH_LOW_BATTERY: 'ALLOW_TAG_ON_WITH_LOW_BATTERY',
    HEALTH_3: 'HEALTH_3',
    ENABLE_LIVE_TAB_ALLOCATION_TARGET_OVERVIEW: 'ENABLE_LIVE_TAB_ALLOCATION_TARGET_OVERVIEW',
    PASTURE_SPRING_RELEASE_24: 'PASTURE_SPRING_RELEASE_24',
    ENABLE_MJME_FEED_REQUIREMENTS: 'ENABLE_MJME_FEED_REQUIREMENTS',
    INSIGHTS_FEEDING_SECTION: 'INSIGHTS_FEEDING_SECTION',
    ALLOW_HEAT_AND_HEALTH_ON_BEEF: 'ALLOW_HEAT_AND_HEALTH_ON_BEEF',
    ENABLE_PASTURE_SPRING_24_PADDOCK_ROTATION: 'ENABLE_PASTURE_SPRING_24_PADDOCK_ROTATION',
    GUIDANCE_SHARED_BOUNDARY_COMMAND_V2: 'GUIDANCE_SHARED_BOUNDARY_COMMAND_V2',
    PASTURE_SPRING_RELEASE_24_FEED_ALLOCATION: 'PASTURE_SPRING_RELEASE_24_FEED_ALLOCATION',
    HEALTH_3_EXTRAS: 'HEALTH_3_EXTRAS',
    PASTURE_SPRING_24_MJME_TARGETS_ALLOCATION_TAB: 'PASTURE_SPRING_24_MJME_TARGETS_ALLOCATION_TAB'
};
/**
 * What type of shifting guidance will use. Passive refers to gentlier cues (vibe), whereas active shifting refers to more active cues (e.g, vibe, piezo and shock)
 * @export
 * @enum {string}
 */
exports.GuidanceShiftProfileEnum = {
    PASSIVE: 'PASSIVE',
    ACTIVE: 'ACTIVE'
};
/**
 * BusinessCleanUpApi - axios parameter creator
 * @export
 */
var BusinessCleanUpApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanUp: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('cleanUp', 'farmId', farmId);
                    localVarPath = "/business/clean-up/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.BusinessCleanUpApiAxiosParamCreator = BusinessCleanUpApiAxiosParamCreator;
/**
 * BusinessCleanUpApi - functional programming interface
 * @export
 */
var BusinessCleanUpApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.BusinessCleanUpApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanUp: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cleanUp(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.BusinessCleanUpApiFp = BusinessCleanUpApiFp;
/**
 * BusinessCleanUpApi - factory interface
 * @export
 */
var BusinessCleanUpApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.BusinessCleanUpApiFp)(configuration);
    return {
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanUp: function (farmId, options) {
            return localVarFp.cleanUp(farmId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.BusinessCleanUpApiFactory = BusinessCleanUpApiFactory;
/**
 * BusinessCleanUpApi - object-oriented interface
 * @export
 * @class BusinessCleanUpApi
 * @extends {BaseAPI}
 */
var BusinessCleanUpApi = /** @class */ (function (_super) {
    __extends(BusinessCleanUpApi, _super);
    function BusinessCleanUpApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} farmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessCleanUpApi
     */
    BusinessCleanUpApi.prototype.cleanUp = function (farmId, options) {
        var _this = this;
        return (0, exports.BusinessCleanUpApiFp)(this.configuration).cleanUp(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BusinessCleanUpApi;
}(base_1.BaseAPI));
exports.BusinessCleanUpApi = BusinessCleanUpApi;
/**
 * FarmApi - axios parameter creator
 * @export
 */
var FarmApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} id
         * @param {IDeleteFarmRequestDTO} iDeleteFarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: function (id, iDeleteFarmRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('_delete', 'id', id);
                    // verify required parameter 'iDeleteFarmRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('_delete', 'iDeleteFarmRequestDTO', iDeleteFarmRequestDTO);
                    localVarPath = "/farms/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDeleteFarmRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {ICreateFarmRequestDTO} iCreateFarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (iCreateFarmRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iCreateFarmRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'iCreateFarmRequestDTO', iCreateFarmRequestDTO);
                    localVarPath = "/farms/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateFarmRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farms/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findbyId: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('findbyId', 'id', id);
                    localVarPath = "/farms/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {IUpdateFarmRequestDTO} iUpdateFarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, iUpdateFarmRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'id', id);
                    // verify required parameter 'iUpdateFarmRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'iUpdateFarmRequestDTO', iUpdateFarmRequestDTO);
                    localVarPath = "/farms/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateFarmRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FarmApiAxiosParamCreator = FarmApiAxiosParamCreator;
/**
 * FarmApi - functional programming interface
 * @export
 */
var FarmApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FarmApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {IDeleteFarmRequestDTO} iDeleteFarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: function (id, iDeleteFarmRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator._delete(id, iDeleteFarmRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ICreateFarmRequestDTO} iCreateFarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (iCreateFarmRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(iCreateFarmRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findAll(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findbyId: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findbyId(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {IUpdateFarmRequestDTO} iUpdateFarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, iUpdateFarmRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.update(id, iUpdateFarmRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FarmApiFp = FarmApiFp;
/**
 * FarmApi - factory interface
 * @export
 */
var FarmApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FarmApiFp)(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {IDeleteFarmRequestDTO} iDeleteFarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: function (id, iDeleteFarmRequestDTO, options) {
            return localVarFp._delete(id, iDeleteFarmRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ICreateFarmRequestDTO} iCreateFarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (iCreateFarmRequestDTO, options) {
            return localVarFp.create(iCreateFarmRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: function (options) {
            return localVarFp.findAll(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findbyId: function (id, options) {
            return localVarFp.findbyId(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {IUpdateFarmRequestDTO} iUpdateFarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, iUpdateFarmRequestDTO, options) {
            return localVarFp.update(id, iUpdateFarmRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FarmApiFactory = FarmApiFactory;
/**
 * FarmApi - object-oriented interface
 * @export
 * @class FarmApi
 * @extends {BaseAPI}
 */
var FarmApi = /** @class */ (function (_super) {
    __extends(FarmApi, _super);
    function FarmApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} id
     * @param {IDeleteFarmRequestDTO} iDeleteFarmRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype._delete = function (id, iDeleteFarmRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration)._delete(id, iDeleteFarmRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ICreateFarmRequestDTO} iCreateFarmRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.create = function (iCreateFarmRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).create(iCreateFarmRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.findAll = function (options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).findAll(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.findbyId = function (id, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).findbyId(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {IUpdateFarmRequestDTO} iUpdateFarmRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.update = function (id, iUpdateFarmRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).update(id, iUpdateFarmRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FarmApi;
}(base_1.BaseAPI));
exports.FarmApi = FarmApi;
/**
 * FarmSettingsApi - axios parameter creator
 * @export
 */
var FarmSettingsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getSettings', 'id', id);
                    localVarPath = "/farms/{id}/settings"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {IUpdateFarmSettingsRequestDTO} iUpdateFarmSettingsRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings: function (id, iUpdateFarmSettingsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateSettings', 'id', id);
                    // verify required parameter 'iUpdateFarmSettingsRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('updateSettings', 'iUpdateFarmSettingsRequestDTO', iUpdateFarmSettingsRequestDTO);
                    localVarPath = "/farms/{id}/settings"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateFarmSettingsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FarmSettingsApiAxiosParamCreator = FarmSettingsApiAxiosParamCreator;
/**
 * FarmSettingsApi - functional programming interface
 * @export
 */
var FarmSettingsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FarmSettingsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSettings(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {IUpdateFarmSettingsRequestDTO} iUpdateFarmSettingsRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings: function (id, iUpdateFarmSettingsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSettings(id, iUpdateFarmSettingsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FarmSettingsApiFp = FarmSettingsApiFp;
/**
 * FarmSettingsApi - factory interface
 * @export
 */
var FarmSettingsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FarmSettingsApiFp)(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: function (id, options) {
            return localVarFp.getSettings(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {IUpdateFarmSettingsRequestDTO} iUpdateFarmSettingsRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings: function (id, iUpdateFarmSettingsRequestDTO, options) {
            return localVarFp.updateSettings(id, iUpdateFarmSettingsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FarmSettingsApiFactory = FarmSettingsApiFactory;
/**
 * FarmSettingsApi - object-oriented interface
 * @export
 * @class FarmSettingsApi
 * @extends {BaseAPI}
 */
var FarmSettingsApi = /** @class */ (function (_super) {
    __extends(FarmSettingsApi, _super);
    function FarmSettingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmSettingsApi
     */
    FarmSettingsApi.prototype.getSettings = function (id, options) {
        var _this = this;
        return (0, exports.FarmSettingsApiFp)(this.configuration).getSettings(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {IUpdateFarmSettingsRequestDTO} iUpdateFarmSettingsRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmSettingsApi
     */
    FarmSettingsApi.prototype.updateSettings = function (id, iUpdateFarmSettingsRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmSettingsApiFp)(this.configuration).updateSettings(id, iUpdateFarmSettingsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FarmSettingsApi;
}(base_1.BaseAPI));
exports.FarmSettingsApi = FarmSettingsApi;
/**
 * FarmStatusApi - axios parameter creator
 * @export
 */
var FarmStatusApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAllFarmStatuses: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farms/status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFarmStatus: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('retrieveFarmStatus', 'farmId', farmId);
                    localVarPath = "/farms/{farmId}/status"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmEmergencyFlagOff: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('setFarmEmergencyFlagOff', 'farmId', farmId);
                    localVarPath = "/farms/{farmId}/status/emergency"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmEmergencyFlagOn: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('setFarmEmergencyFlagOn', 'farmId', farmId);
                    localVarPath = "/farms/{farmId}/status/emergency"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmMaintenanceFlagOff: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('setFarmMaintenanceFlagOff', 'farmId', farmId);
                    localVarPath = "/farms/{farmId}/status/maintenance"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmMaintenanceFlagOn: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('setFarmMaintenanceFlagOn', 'farmId', farmId);
                    localVarPath = "/farms/{farmId}/status/maintenance"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmToLapsed: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('setFarmToLapsed', 'farmId', farmId);
                    localVarPath = "/farms/{farmId}/status/lapsed"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmToLive: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('setFarmToLive', 'farmId', farmId);
                    localVarPath = "/farms/{farmId}/status/live"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmToNotLapsed: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('setFarmToNotLapsed', 'farmId', farmId);
                    localVarPath = "/farms/{farmId}/status/lapsed"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmToNotLive: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('setFarmToNotLive', 'farmId', farmId);
                    localVarPath = "/farms/{farmId}/status/live"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FarmStatusApiAxiosParamCreator = FarmStatusApiAxiosParamCreator;
/**
 * FarmStatusApi - functional programming interface
 * @export
 */
var FarmStatusApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FarmStatusApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAllFarmStatuses: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveAllFarmStatuses(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFarmStatus: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveFarmStatus(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmEmergencyFlagOff: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setFarmEmergencyFlagOff(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmEmergencyFlagOn: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setFarmEmergencyFlagOn(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmMaintenanceFlagOff: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setFarmMaintenanceFlagOff(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmMaintenanceFlagOn: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setFarmMaintenanceFlagOn(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmToLapsed: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setFarmToLapsed(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmToLive: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setFarmToLive(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmToNotLapsed: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setFarmToNotLapsed(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmToNotLive: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setFarmToNotLive(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FarmStatusApiFp = FarmStatusApiFp;
/**
 * FarmStatusApi - factory interface
 * @export
 */
var FarmStatusApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FarmStatusApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAllFarmStatuses: function (options) {
            return localVarFp.retrieveAllFarmStatuses(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFarmStatus: function (farmId, options) {
            return localVarFp.retrieveFarmStatus(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmEmergencyFlagOff: function (farmId, options) {
            return localVarFp.setFarmEmergencyFlagOff(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmEmergencyFlagOn: function (farmId, options) {
            return localVarFp.setFarmEmergencyFlagOn(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmMaintenanceFlagOff: function (farmId, options) {
            return localVarFp.setFarmMaintenanceFlagOff(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmMaintenanceFlagOn: function (farmId, options) {
            return localVarFp.setFarmMaintenanceFlagOn(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmToLapsed: function (farmId, options) {
            return localVarFp.setFarmToLapsed(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmToLive: function (farmId, options) {
            return localVarFp.setFarmToLive(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmToNotLapsed: function (farmId, options) {
            return localVarFp.setFarmToNotLapsed(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFarmToNotLive: function (farmId, options) {
            return localVarFp.setFarmToNotLive(farmId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FarmStatusApiFactory = FarmStatusApiFactory;
/**
 * FarmStatusApi - object-oriented interface
 * @export
 * @class FarmStatusApi
 * @extends {BaseAPI}
 */
var FarmStatusApi = /** @class */ (function (_super) {
    __extends(FarmStatusApi, _super);
    function FarmStatusApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmStatusApi
     */
    FarmStatusApi.prototype.retrieveAllFarmStatuses = function (options) {
        var _this = this;
        return (0, exports.FarmStatusApiFp)(this.configuration).retrieveAllFarmStatuses(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} farmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmStatusApi
     */
    FarmStatusApi.prototype.retrieveFarmStatus = function (farmId, options) {
        var _this = this;
        return (0, exports.FarmStatusApiFp)(this.configuration).retrieveFarmStatus(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} farmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmStatusApi
     */
    FarmStatusApi.prototype.setFarmEmergencyFlagOff = function (farmId, options) {
        var _this = this;
        return (0, exports.FarmStatusApiFp)(this.configuration).setFarmEmergencyFlagOff(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} farmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmStatusApi
     */
    FarmStatusApi.prototype.setFarmEmergencyFlagOn = function (farmId, options) {
        var _this = this;
        return (0, exports.FarmStatusApiFp)(this.configuration).setFarmEmergencyFlagOn(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} farmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmStatusApi
     */
    FarmStatusApi.prototype.setFarmMaintenanceFlagOff = function (farmId, options) {
        var _this = this;
        return (0, exports.FarmStatusApiFp)(this.configuration).setFarmMaintenanceFlagOff(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} farmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmStatusApi
     */
    FarmStatusApi.prototype.setFarmMaintenanceFlagOn = function (farmId, options) {
        var _this = this;
        return (0, exports.FarmStatusApiFp)(this.configuration).setFarmMaintenanceFlagOn(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} farmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmStatusApi
     */
    FarmStatusApi.prototype.setFarmToLapsed = function (farmId, options) {
        var _this = this;
        return (0, exports.FarmStatusApiFp)(this.configuration).setFarmToLapsed(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} farmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmStatusApi
     */
    FarmStatusApi.prototype.setFarmToLive = function (farmId, options) {
        var _this = this;
        return (0, exports.FarmStatusApiFp)(this.configuration).setFarmToLive(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} farmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmStatusApi
     */
    FarmStatusApi.prototype.setFarmToNotLapsed = function (farmId, options) {
        var _this = this;
        return (0, exports.FarmStatusApiFp)(this.configuration).setFarmToNotLapsed(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} farmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmStatusApi
     */
    FarmStatusApi.prototype.setFarmToNotLive = function (farmId, options) {
        var _this = this;
        return (0, exports.FarmStatusApiFp)(this.configuration).setFarmToNotLive(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FarmStatusApi;
}(base_1.BaseAPI));
exports.FarmStatusApi = FarmStatusApi;
/**
 * FeatureFlagsApi - axios parameter creator
 * @export
 */
var FeatureFlagsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} id
         * @param {IDeleteFeatureFlagRequestDTO} iDeleteFeatureFlagRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeatureFlag: function (id, iDeleteFeatureFlagRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteFeatureFlag', 'id', id);
                    // verify required parameter 'iDeleteFeatureFlagRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('deleteFeatureFlag', 'iDeleteFeatureFlagRequestDTO', iDeleteFeatureFlagRequestDTO);
                    localVarPath = "/farms/{id}/feature-flags"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDeleteFeatureFlagRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {FeatureFlagNamesEnum} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllFarmFeatureFlagStatuses: function (name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'name' is not null or undefined
                    (0, common_1.assertParamExists)('findAllFarmFeatureFlagStatuses', 'name', name);
                    localVarPath = "/feature-flags/{name}/farms"
                        .replace("{".concat("name", "}"), encodeURIComponent(String(name)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllFeatureFlags: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('findAllFeatureFlags', 'id', id);
                    localVarPath = "/farms/{id}/feature-flags"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {IUpdateFeatureFlagRequestDTO} iUpdateFeatureFlagRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFeatureFlag: function (id, iUpdateFeatureFlagRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('saveFeatureFlag', 'id', id);
                    // verify required parameter 'iUpdateFeatureFlagRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('saveFeatureFlag', 'iUpdateFeatureFlagRequestDTO', iUpdateFeatureFlagRequestDTO);
                    localVarPath = "/farms/{id}/feature-flags"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateFeatureFlagRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FeatureFlagsApiAxiosParamCreator = FeatureFlagsApiAxiosParamCreator;
/**
 * FeatureFlagsApi - functional programming interface
 * @export
 */
var FeatureFlagsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FeatureFlagsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {IDeleteFeatureFlagRequestDTO} iDeleteFeatureFlagRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeatureFlag: function (id, iDeleteFeatureFlagRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFeatureFlag(id, iDeleteFeatureFlagRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {FeatureFlagNamesEnum} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllFarmFeatureFlagStatuses: function (name, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findAllFarmFeatureFlagStatuses(name, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllFeatureFlags: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findAllFeatureFlags(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {IUpdateFeatureFlagRequestDTO} iUpdateFeatureFlagRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFeatureFlag: function (id, iUpdateFeatureFlagRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.saveFeatureFlag(id, iUpdateFeatureFlagRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FeatureFlagsApiFp = FeatureFlagsApiFp;
/**
 * FeatureFlagsApi - factory interface
 * @export
 */
var FeatureFlagsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FeatureFlagsApiFp)(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {IDeleteFeatureFlagRequestDTO} iDeleteFeatureFlagRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeatureFlag: function (id, iDeleteFeatureFlagRequestDTO, options) {
            return localVarFp.deleteFeatureFlag(id, iDeleteFeatureFlagRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {FeatureFlagNamesEnum} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllFarmFeatureFlagStatuses: function (name, options) {
            return localVarFp.findAllFarmFeatureFlagStatuses(name, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllFeatureFlags: function (id, options) {
            return localVarFp.findAllFeatureFlags(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {IUpdateFeatureFlagRequestDTO} iUpdateFeatureFlagRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFeatureFlag: function (id, iUpdateFeatureFlagRequestDTO, options) {
            return localVarFp.saveFeatureFlag(id, iUpdateFeatureFlagRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FeatureFlagsApiFactory = FeatureFlagsApiFactory;
/**
 * FeatureFlagsApi - object-oriented interface
 * @export
 * @class FeatureFlagsApi
 * @extends {BaseAPI}
 */
var FeatureFlagsApi = /** @class */ (function (_super) {
    __extends(FeatureFlagsApi, _super);
    function FeatureFlagsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} id
     * @param {IDeleteFeatureFlagRequestDTO} iDeleteFeatureFlagRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    FeatureFlagsApi.prototype.deleteFeatureFlag = function (id, iDeleteFeatureFlagRequestDTO, options) {
        var _this = this;
        return (0, exports.FeatureFlagsApiFp)(this.configuration).deleteFeatureFlag(id, iDeleteFeatureFlagRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {FeatureFlagNamesEnum} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    FeatureFlagsApi.prototype.findAllFarmFeatureFlagStatuses = function (name, options) {
        var _this = this;
        return (0, exports.FeatureFlagsApiFp)(this.configuration).findAllFarmFeatureFlagStatuses(name, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    FeatureFlagsApi.prototype.findAllFeatureFlags = function (id, options) {
        var _this = this;
        return (0, exports.FeatureFlagsApiFp)(this.configuration).findAllFeatureFlags(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {IUpdateFeatureFlagRequestDTO} iUpdateFeatureFlagRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    FeatureFlagsApi.prototype.saveFeatureFlag = function (id, iUpdateFeatureFlagRequestDTO, options) {
        var _this = this;
        return (0, exports.FeatureFlagsApiFp)(this.configuration).saveFeatureFlag(id, iUpdateFeatureFlagRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FeatureFlagsApi;
}(base_1.BaseAPI));
exports.FeatureFlagsApi = FeatureFlagsApi;
